module.exports = __webpack_public_path__ + "img/second-day-6.0401047d.png";